module.exports = __webpack_public_path__ + "static/img/salud-comunitaria.517d5747.png";